import React, { useEffect, useState, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { isEmpty } from "lodash"
import ReactTooltip from "react-tooltip"
import history from "app/history"

import PageContainer from "components/common/PageContainer"
import Button from "components/common/Button"
import { amountFormatter } from "helpers/util"

// import { useWallet } from "hooks/use-wallet"
// import { L2E_OWNER_ADDRESS } from "constants/config"

import { fetchTransactionDetails } from "store/courses/action"
import { getWalletBalance } from "store/user/actions"

import ImagePlaceholder from "assets/images/imageplaceholder.png"
import "styles/pages/payment-result.scss"
import { toast } from "react-toastify"
import { APT_COIN_RATE } from "constants/config"

const PaymentResultPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isLoading = useSelector((state) => state.authReducer.isLoading)
  // const walletDetails = useSelector((state) => state.userReducer.walletDetails)
  const payment =
    useSelector((state) => state.coursesReducer.transactionDetails) || {}
  const [itemDetails, setItemDetails] = useState({})
  const [title, setTitle] = useState("")
  const [paymentStatus, setPaymentStatus] = useState()
  const [description, setDescription] = useState("")
  const queryParams = new URLSearchParams(location.search)
  const transactionId = queryParams.get("txn_id")

  // const {
  //   walletBalance,
  //   walletAddress,
  //   isWalletConnected,
  //   isVerifyingAddress,
  //   transferToken,
  //   loadWeb3Modal,
  // } = useWallet()

  // const { address: registeredWalletAddress } = walletDetails || {}

  // const transferCoins = () => {
  //   transferToken(L2E_OWNER_ADDRESS, "10")
  // }

  const handleViewItem = () => {
    if (itemDetails?.id) {
      switch (itemDetails?.content_type) {
        case "course":
          history.push(`/course/${itemDetails?.slug}`)
          break
        case "coursebundle":
          history.push(`/course-bundle/${itemDetails?.slug}`)
          break
        default:
          break
      }
    }
  }

  const handleReturnToPayment = () => {
    if (itemDetails?.id) {
      switch (itemDetails?.content_type) {
        case "course":
          history.push(`/course/payment/${itemDetails?.slug}`)
          break
        case "bundle":
          history.push(`/course-bundle/payment/${itemDetails?.slug}`)
          break
        default:
          break
      }
    }
  }

  useEffect(() => {
    if (isEmpty(transactionId)) {
      toast.error("Invalid Transaction ID")
      history.push("")
    } else {
      dispatch(fetchTransactionDetails(transactionId))
      dispatch(getWalletBalance())
    }
  }, [transactionId, dispatch])

  useEffect(() => {
    if (!isEmpty(payment)) {
      setItemDetails(payment?.object_details || {})
      setPaymentStatus(payment?.status)
    }
  }, [payment])

  useEffect(() => {
    if (paymentStatus) {
      switch (paymentStatus) {
        case "Paid":
          setTitle("Thank you!")
          setDescription("Your payment has been successfully processed.")
          break
        case "notpaid":
          setTitle("Oops...")
          setDescription("Your payment has not been processed.")
          break
        case "Pending":
          let description = `Thank you for enrolling to this course${
            itemDetails?.content_type === "coursebundle" ? " bundle" : ""
          }. You can start learning once we confirm your payment.`
          setTitle("Payment Pending")
          setDescription(description)
          break
        default:
          toast.error("Invalid Payment Status")
          history.push("")
          break
      }
    }
  }, [paymentStatus, itemDetails])

  const coinRate = APT_COIN_RATE

  // const walletAddressMatched = registeredWalletAddress === walletAddress

  const coinsApplied = payment.applied_coins && payment.applied_coins > 0

  const paymentMethod = `${payment?.processor_type} ${
    payment?.processor ? `- ${payment?.processor}` : ""
  }`

  return (
    <Fragment>
      <PageContainer isPageLoading={isLoading}>
        <div className="payment-result-container">
          <div className="hero-header">
            <div className="hero-wrapper">
              <h1 className="title">{title}</h1>
              <p className="description">{description}</p>
              {/* {coinsApplied && (
                <p className="description">
                  Please transfer the applied L2E coins to complete the payment.
                </p>
              )} */}
            </div>
          </div>
          <div className="page-wrapper -payment-result">
            <div className="content">
              <div className="item-details-container">
                <img
                  src={itemDetails?.image || ImagePlaceholder}
                  width="100%"
                  alt="item"
                />
                <div className="wrapper">
                  <div className="item-details">
                    <div className="item-title">{itemDetails?.name}</div>
                    <div className="item-description">
                      {itemDetails?.description}
                    </div>
                  </div>
                </div>
              </div>
              <div className="payment-summary">
                <p className="title">Payment Summary</p>
                <div className="payment-details">
                  <p className="item">Subtotal</p>
                  <p className="price">{`${amountFormatter(payment?.base)}`}</p>
                  <p className="item">Value-Added Tax</p>
                  <p className="price">{`${amountFormatter(payment?.vat)}`}</p>
                  {payment?.fee > 0 && (
                    <>
                      <p className="item">Payment Gateway Fee</p>
                      <p className="price">{amountFormatter(payment?.fee)}</p>
                    </>
                  )}
                  {payment?.discount > 0 && (
                    <>
                      <p className="item">Voucher Code</p>
                      <p className="price">
                        {amountFormatter(-payment?.discount)}
                      </p>
                    </>
                  )}
                  {coinsApplied && (
                    <>
                      <p className="item">
                        L2E Coins
                        <span
                          className="icon"
                          data-tip={`1 L2E = ₱ ${amountFormatter(coinRate)}`}
                        >
                          <i className="fas fa-info-circle"></i>
                        </span>
                      </p>
                      <p className="price">
                        {amountFormatter(-payment?.applied_coins * coinRate)}
                      </p>
                      <ReactTooltip place="right" effect="solid" />
                    </>
                  )}
                  <p className="item -final">Total Payment</p>
                  <p className="price -final">{`${amountFormatter(
                    payment?.amount
                  )}`}</p>
                </div>
                <p className="label">Mode of Payment</p>
                <p className="subtitle">{paymentMethod}</p>
                {/* {coinsApplied && (
                  <>
                    {isWalletConnected ? (
                      <>
                        <Button
                          block
                          label={`Transfer ${amountFormatter(
                            payment?.applied_coins
                          )} L2E Coins`}
                          disabled={!walletAddressMatched}
                          onClick={transferCoins}
                        />
                        {!walletAddressMatched && (
                          <p className="wallet-hint">
                            Please switch to your account at{" "}
                            {registeredWalletAddress?.substring(0, 6)}...
                          </p>
                        )}
                      </>
                    ) : (
                      <Button
                        block
                        label="Connect Wallet"
                        disabled={isVerifyingAddress}
                        onClick={loadWeb3Modal}
                      />
                    )}
                  </>
                )} */}
                {["Paid", "Pending"].includes(paymentStatus) ? (
                  <Button
                    block
                    onClick={handleViewItem}
                    label={`View Course ${
                      itemDetails?.content_type === "coursebundle"
                        ? " Bundle"
                        : ""
                    }`}
                  />
                ) : paymentStatus === "Failed" ? (
                  <Button
                    block
                    onClick={handleReturnToPayment}
                    label={`Return to Payment Page`}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
    </Fragment>
  )
}

export default PaymentResultPage
